import { get, post } from '@api/request';

export async function fetchAllJobs(
  { recalculationService },
  authenticationToken,
) {
  const url = `${recalculationService}/recalc/jobs`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMarketArea(
  { appraisalService },
  authenticationToken,
  { year },
) {
  const url = `${appraisalService}/appraisal/codes?type=Property&year=${year}&name=Market Area`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCurrentAppraisalYear(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/currentyear`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createRecalcJob(
  { recalculationService },
  authenticationToken,
  { data },
) {
  const url = `${recalculationService}/recalc/jobs`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchRecalcJob(
  { recalculationService },
  authenticationToken,
  { recalcID },
) {
  const url = `${recalculationService}/recalc/job/${recalcID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}


export async function fetchRecalcJobErrors(
  { recalculationService },
  authenticationToken,
  { recalcID, page, pageSize },
) {
  const url = `${recalculationService}/recalc/job/${recalcID}/errors?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}
